import React from 'react';
import { useTranslation } from 'react-i18next';

import './ShowCombinations.scss';
import Icon from '../../Icon/Icon';

interface CombinationsProps {
  totalCombinations?: number,
  onClick?: () => void,
  stakes?: number[],
  isQuickBet: boolean,
  isNumberBet?:boolean
  repetitionsCount?: number
}

export default function ShowCombinations({ totalCombinations, onClick, isQuickBet, stakes, repetitionsCount, isNumberBet=true } :CombinationsProps) {
  const { t } = useTranslation();

  return (
    <div className="slip-form__combinations">
      {
        !isQuickBet &&(
          <>
            <Icon icon="trash" className="slip-form__clear" onClick={ onClick } />
            { t('betslip.combinationsLabel') }: { totalCombinations }
            <a href={ stakes.length > 0 ? '#permutations' : null } className="slip-form__combinations-link">{ t('betslip.showCombinations') }</a>
          </>
        )
      }

      {
        isQuickBet && (
          <div className="slip-form__quickbet-combinations">
            {
              isNumberBet && (
                `${ t('betConfirmation.draws') } ${ repetitionsCount }`
              )
            }
            <span
              className="slip-form__combinations-link slip-form__combinations-link--nohref"
              onClick={ onClick }
            >{ t('betslip.showCombinations') } ({ totalCombinations })</span>
          </div>
        )
      }
    </div>
  );
}
